import type { DialogProps } from './Dialog.types';
import type { ReactElement } from 'react';

import { Sheet } from '@rango-dev/whale/lab';
import React from 'react';

import { useMediaQuery } from '../../hooks/useMediaQuery';

import { DesktopDialog } from './Dialog.Desktop';

/**
 * Responsive dialog — a centered Radix Themes Dialog from 640px up, the local
 * `Sheet` (bottom sheet) below it. Same prop surface as `Sheet`, plus a
 * desktop-only `width`. The `width` prop is harmlessly ignored on the sheet.
 */
export function Dialog(props: DialogProps): ReactElement {
  const isDesktop = useMediaQuery('(min-width: 640px)');
  return isDesktop ? <DesktopDialog {...props} /> : <Sheet {...props} />;
}
